import {createFileRoute} from '@tanstack/react-router';
import {SupportMessagePage} from 'pages/support/messages/SupportMessagePage';

export const Route = createFileRoute('/_protected/home/service/messages')({
  component: SupportMessagePage,
  staticData: {crumbKey: 'navigation.messages'},
});
